import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import CloseIcon from "@mui/icons-material/Close";
import { Box, DialogTitle, Drawer, DrawerProps } from "@mui/material";
import { ReactNode } from "react";
import Flex from "./Flex";
import { ScrollArea } from "./ScrollBar";
import Text from "./Text";

type Position = "top" | "left" | "right" | "bottom";

type StyledDrawerProps = {
  title?: string;
  backButton?: ReactNode;
  open: boolean;
  onClose: () => void;
  bottomFixedAction?: boolean;
  children: ReactNode;
  pos?: Position;
  centerTitle?: boolean;
  withCloseIcon?: boolean;
  w?: string | number;
  drawerAction?: ReactNode;
  endIcon?: ReactNode;
  disableCloseOutside?: boolean;
} & DrawerProps;

const StyledDrawer = ({
  open,
  title,
  onClose,
  pos = "right",
  centerTitle,
  withCloseIcon = true,
  w,
  drawerAction,
  children,
  backButton,
  endIcon,
  bottomFixedAction,
  disableCloseOutside = true,
  ...others
}: StyledDrawerProps) => {
  return (
    <Drawer
      open={open}
      disableEscapeKeyDown
      onClose={() => (disableCloseOutside ? undefined : onClose)}
      title={typeof title === "string" ? title : undefined}
      anchor={pos}
      PaperProps={{ sx: { width: w }, title: "" }}
      sx={(theme) => ({
        zIndex: theme.zIndex.modal,
      })}
      {...others}
    >
      <DialogTitle
        style={{
          padding: "24px 14px 24px 16px",
        }}
      >
        <Flex justifyContent={"space-between"} alignItems={"center"}>
          <Flex
            width={"100%"}
            alignItems={"center"}
            justifyContent={centerTitle ? "center" : undefined}
          >
            {backButton && (
              <ArrowBackIcon
                color={others?.color as any}
                sx={{
                  cursor: "pointer",
                }}
                fontSize="medium"
                onClick={onClose}
              />
            )}
            <Text
              fontSize={"16px"}
              fontWeight={"medium"}
              c={others?.color}
              sx={{ cursor: backButton ? "pointer" : undefined }}
              onClick={backButton ? onClose : undefined}
            >
              {title}
            </Text>
          </Flex>
          <Flex
            gap={"10px"}
            alignItems={"center"}
            width={"100%"}
            justifyContent={"end"}
          >
            {endIcon && endIcon}

            {withCloseIcon && (
              <CloseIcon sx={{ cursor: "pointer" }} onClick={onClose} />
            )}
          </Flex>
        </Flex>
      </DialogTitle>

      <ScrollArea height="inherit" mb={bottomFixedAction ? "50px" : "10px"}>
        <Box padding={2} paddingTop={1} height={"inherit"}>
          <Box mb={bottomFixedAction ? "50px" : undefined}>{children}</Box>

          {drawerAction && (
            <Flex
              alignItems={"center"}
              justifyContent={"end"}
              width={"100%"}
              mt={"20px"}
              position={bottomFixedAction ? "fixed" : undefined}
              bottom={"16px"}
              right={"18px"}
            >
              {drawerAction}
            </Flex>
          )}
        </Box>
      </ScrollArea>
    </Drawer>
  );
};

export default StyledDrawer;
